import Card from '../components/Card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Gift, TrendingUp, Award } from 'lucide-react';

const rewardsData = [
    { date: '2024-03-01', points: 120 },
    { date: '2024-03-02', points: 150 },
    { date: '2024-03-03', points: 180 },
    { date: '2024-03-04', points: 220 },
    { date: '2024-03-05', points: 250 },
];

export default function Rewards() {
    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-gray-900">Rewards</h1>

            <div className="grid md:grid-cols-3 gap-6">
                <Card className="bg-gradient-to-br from-[#001f3f] to-navy-700 text-white">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-200">Total Points</p>
                            <h3 className="text-3xl font-bold mt-1">2,458</h3>
                        </div>
                        <Gift size={32} className="opacity-80" />
                    </div>
                </Card>

                <Card>
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600">This Month</p>
                            <h3 className="text-xl font-semibold mt-1">+458 points</h3>
                        </div>
                        <TrendingUp size={24} className="text-green-500" />
                    </div>
                </Card>

                <Card>
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600">Current Tier</p>
                            <h3 className="text-xl font-semibold mt-1">Gold</h3>
                        </div>
                        <Award size={24} className="text-yellow-500" />
                    </div>
                </Card>
            </div>

            <Card title="Points History">
                <div className="h-[300px]">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={rewardsData}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                            <XAxis dataKey="date" stroke="#6b7280" />
                            <YAxis stroke="#6b7280" />
                            <Tooltip />
                            <Line
                                type="monotone"
                                dataKey="points"
                                stroke="#001f3f"
                                strokeWidth={2}
                                dot={{ fill: '#001f3f' }}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </Card>

            <Card title="Recent Bonuses">
                <div className="space-y-4">
                    {[
                        { title: 'Welcome Bonus', points: 100, date: '2024-03-10' },
                        { title: 'Purchase Reward', points: 50, date: '2024-03-09' },
                        { title: 'Referral Bonus', points: 200, date: '2024-03-08' },
                    ].map((bonus, i) => (
                        <div key={i} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                            <div>
                                <h4 className="font-medium text-gray-900">{bonus.title}</h4>
                                <p className="text-sm text-gray-600">{bonus.date}</p>
                            </div>
                            <span className="text-green-600 font-medium">+{bonus.points} points</span>
                        </div>
                    ))}
                </div>
            </Card>
        </div>
    );
}